export enum TicketStatuses {
  open = 'O',
  closed = 'C',
  working = 'W',
  reviewing = 'R'
}
